import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { desEncriptar, encriptar } from "../utilities/encriptacion";
import RouterAuth from "./RouterAuth/RouterAuth";
import RouterGuest from "./RouterGuest/RouterGuest";
import '../index.scss'
import MenuFrontal from "../components/molecules/MenuFrontal/MenuFrontal";
import 'primereact/resources/themes/saga-blue/theme.css';  // Tema PrimeReact
import 'primereact/resources/primereact.min.css';           // Estilos de PrimeReact
import 'primeicons/primeicons.css';
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const MainRouter = () => {
    const [auth, setAuth] = useState(false)
    useEffect(() => {
        const clave = process.env.REACT_APP_CLAVE_INCRIPTACION
        if (sessionStorage.getItem('authMonitor')) {
            const autLocal = sessionStorage.getItem('authMonitor')
            if (desEncriptar(autLocal, clave) == "false") {
                setAuth(false)
            }
            else {
                setAuth(true)
            }
        }
        else {
            sessionStorage.setItem('authMonitor', encriptar(`${auth}`, clave));
        }
    }, [])


    
    return (
        <BrowserRouter>
            {
                auth ?
                    <>
                    <MenuFrontal>
                        <RouterAuth></RouterAuth>
                    </MenuFrontal>
                    
                    </>

                    :
                    <RouterGuest ></RouterGuest>
            }
            
        </BrowserRouter>
    )
}
export default MainRouter